var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_8373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9926 8.1497C14.9926 7.49419 14.9416 7.01584 14.8311 6.51978H7.6499V9.47843H11.8651C11.7802 10.2137 11.3212 11.321 10.3014 12.0651L10.2871 12.1641L12.5577 13.9976L12.715 14.0139C14.1597 12.6232 14.9926 10.5769 14.9926 8.1497Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64946 15.9451C9.71457 15.9451 11.4482 15.2364 12.7146 14.014L10.301 12.0651C9.6551 12.5346 8.78824 12.8623 7.64946 12.8623C5.62683 12.8623 3.91015 11.4716 3.2982 9.54932L3.2085 9.55726L0.847526 11.4618L0.81665 11.5513C2.07442 14.1556 4.65797 15.9451 7.64946 15.9451Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29798 9.54936C3.13652 9.0533 3.04307 8.52176 3.04307 7.97257C3.04307 7.42332 3.13652 6.89184 3.28949 6.39577L3.28521 6.29013L0.894659 4.35498L0.816444 4.39376C0.29806 5.47449 0.000610352 6.68811 0.000610352 7.97257C0.000610352 9.25703 0.29806 10.4706 0.816444 11.5513L3.29798 9.54936Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64944 3.08269C9.08566 3.08269 10.0545 3.72934 10.6069 4.26974L12.7655 2.07286C11.4398 0.788397 9.71454 0 7.64944 0C4.65795 0 2.07441 1.78937 0.81665 4.39371L3.2897 6.39573C3.91014 4.47347 5.62682 3.08269 7.64944 3.08269Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_8373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/icGoogle.2846e84c831696696b0cf4e193325bd4.svg";
export { ForwardRef as ReactComponent };